/* eslint-disable camelcase */
import { Amplify } from 'aws-amplify';
import config from './config';

export const configureAmplify = () => {
    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: config.cognito.USER_POOL_ID!,
                userPoolClientId: config.cognito.APP_CLIENT_ID!,
                identityPoolId: config.cognito.IDENTITY_POOL_ID!,
            }
        },
        API: {
            REST: {
                apartments: {
                    endpoint: config.apiGateway.apartments.URL!,
                    region: config.apiGateway.apartments.REGION!
                },
                applications: {
                    endpoint: config.apiGateway.applications.URL!,
                    region: config.apiGateway.applications.REGION!
                },
                showings: {
                    endpoint: config.apiGateway.showings.URL!,
                    region: config.apiGateway.showings.REGION!
                },
                users: {
                    endpoint: config.apiGateway.users.URL!,
                    region: config.apiGateway.users.REGION!
                },
                applicantAvailability: {
                    endpoint: config.apiGateway.applicantAvailability.URL!,
                    region: config.apiGateway.applicantAvailability.REGION!
                },
                instantRent: {
                    endpoint: config.apiGateway.instantRent.URL!,
                    region: config.apiGateway.instantRent.REGION!
                },
                applicantWatchers: {
                    endpoint: config.apiGateway.applicantWatchers.URL!,
                    region: config.apiGateway.applicantWatchers.REGION!
                }
            }
        },
        Storage: {
            S3: {
                bucket: config.s3.transcodedMedia.BUCKET!,
                region: config.s3.transcodedMedia.REGION!
            }
        }
    } as any);
};
